import { FaInfoCircle, FaPencilAlt, FaTrashAlt } from 'react-icons/fa'
import { MdAddPhotoAlternate } from 'react-icons/md'
import { Link } from 'react-router-dom'

import { Avatar } from '../../../../../components/Avatar'
import { Badge } from '../../../../../components/Badge'
import { Button } from '../../../../../components/Button'
import { usePermission } from '../../../../../hooks/usePermission'
import { Report } from '../../../../../services/reportServices'
import { formatDateRelativeTime } from '../../../../../utils/formatDateRelativeTime'

interface TableReportsRowProps {
  report: Report
  onRemove: (id: string, name: Report['store']) => Promise<void>
  onEdit: (report: Report) => void
  onAddImages: (report: Report) => void
}

export function ReportsTableRow({ report, onRemove, onEdit, onAddImages }: TableReportsRowProps) {
  const { upsertReport, isObserver } = usePermission()

  return (
    <tr
      className="border-t border-slate-500 hover:bg-white_transparency hover:bg-opacity-15"
    >
      <td
        scope="row"
        className="font-medium whitespace-nowrap sticky left-0 border-slate-500 w-12"
      >
        <div className="rounded-md overflow-hidden p-2 ">
          <Avatar className="w-10 h-10" imageUrl={report.store.group.logo_url} />
        </div>
      </td>
      <td
        scope="row"
        className="font-medium text-dark whitespace-nowrap sticky left-0 border-r border-slate-500 p-2"
      >
        <span>{report.store.name}</span>
      </td>
      <td
        scope="row"
        className="font-medium text-dark whitespace-nowrap sticky left-0 border-r border-slate-500 p-2 text-center"
      >
        <span>{`${report.store.city} - ${report.store.state}`}</span>
      </td>
      <td
        scope="row"
        className="font-medium text-dark whitespace-nowrap sticky left-0 border-r border-slate-500 p-2 text-center"
      >
        <span>{formatDateRelativeTime(report.updated_at)}</span>
      </td>
      <td
        scope="row"
        className="font-medium text-dark whitespace-nowrap sticky left-0 border-r border-slate-500 p-2 text-center"
      >
        {report.has_promoter_problem &&
          <Badge status={report.has_promoter_problem} title="Promotor" />}
        {report.report_product_problem.length > 0 &&
          <Badge status={report.report_product_problem.length > 0} title="Produto" />}
        {(report.report_product_problem.length === 0 && !report.has_promoter_problem) &&
          <Badge status={false} title="Tudo ok" />}
      </td>
      <td
        scope="row"
        className="font-medium text-dark whitespace-nowrap sticky left-0 p-2 text-center"
      >
        <div className="flex flex-row space-x-2 justify-end">
          {upsertReport && !isObserver &&
            <Button
              size="icon"
              title="Deletar relatório"
              variant="danger"
              onClick={() => onRemove(report.id, report.store)}
            >
              <FaTrashAlt />
            </Button>}
          <Link to={`/reports/${report.id}`}>
            <Button
              type="button"
              size="icon"
              title="Detalhes"
            >
              <FaInfoCircle />
            </Button>
          </Link>
          {!isObserver && (
            <Button
              type="button"
              size="icon"
              title="Adicionar imagens"
              onClick={() => onAddImages(report)}
            >
              <MdAddPhotoAlternate />
            </Button>
          )}
          <Button
            size="icon"
            title="Editar relatório"
            disabled={!upsertReport || isObserver}
            onClick={() => onEdit(report)}
            className="disabled:bg-slate-400 hover:disabled:bg-slate-400 disabled:cursor-not-allowed"
          >
            <FaPencilAlt />
          </Button>
        </div>
      </td>
    </tr>
  )
}
